import React, { useState, useEffect, useContext } from 'react';
import { IoCloseSharp } from "react-icons/io5";
import { motion } from 'framer-motion';
import ButtonWhite from '../../button/ButtonWhite';
import ButtonBack from '../../button/ButtonBack';
import ModalAlert from '../ModalAlert'
import SingleQR from "../../layouts/home/depositar/SingleQR";
import axios from 'axios';


import { formatMontoCop } from '../../../utils/FormatBalanceCop'
import { formatCurrency } from '../../../utils/FormatCurrency'



import SelectWallet from '../../layouts/home/depositar/SelectWallet';
import SelectBuyColurs from '../../layouts/home/depositar/SelectBuyColurs';
import DepositarPSE from '../../layouts/home/depositar/DepositarPSE'
import MultiQr from '../../layouts/home/depositar/MultiQr'
import BanckTransfert from '../../layouts/home/depositar/TransfertBanck'
import { AuthContext } from '../../../context/AuthContext';
import moment from 'moment';
import { getHashKey } from '../../../functions/createSignImages';

import { ReactComponent as Check } from '../../../assets/IconsColurs/IconsGeneral/checkFilled.svg'



import Cop from '../../../assets/currency/copu.png';
import Usd from '../../../assets/currency/usd.png';



const ModalQuote = ({
    activeQoute,
    setActiveQoute,

}) => {
    const { getAuthenticatedHeaders, } = useContext(AuthContext);
    const [loadingAddressQr, setLoadingAddressQr] = useState(false)
    const [addressQrUSDT, setAddressQrUSDT] = useState('');
    const [addressQrUSDC, setAddressQrUSDC] = useState('');
    const [paso, setPaso] = useState(1);
    const [walletCop, setWalletCop] = useState(true);
    const [buttonActive, setButtonActive] = useState(false)
    const [bank, setBank] = useState(null)
    const { DetailUser } = useContext(AuthContext);

    const [listCountry, setListCountry] = useState([])
    const [currencyList, setCurrencyList] = useState([
        {
            code: "COP",
            name: "COP"
        },
        {
            code: "USD",
            name: "USD"
        }
    ])




    const [banck, setBack] = useState('')




    const QrAddressFech = async () => {
        setLoadingAddressQr(true)

        await axios
            .post(`/api/address_qr`, {
                headers: await getAuthenticatedHeaders(),
                "coin": "usdc",
                "is_otc": "true",
                "wallet_type": "QUOTATION"

            })
            .then((response) => {
                setAddressQrUSDC(response.data.data.address)
            })
            .catch((error) => {
                setLoadingAddressQr(false)
            });

        setLoadingAddressQr(false)
    }
    const QrAddressFechUSDC = async () => {
        setLoadingAddressQr(true)

        await axios
            .post(`/api/address_qr`, {
                headers: await getAuthenticatedHeaders(),
                "coin": "usdt",
                "is_otc": "true",
                "wallet_type": "QUOTATION"
            })
            .then((response) => {
                setAddressQrUSDT(response.data.data.address)
            })
            .catch((error) => {
                setLoadingAddressQr(false)
            });

        setLoadingAddressQr(false)
    }




    const modalVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: {
            scale: 1,
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" }
        },
        exit: {
            scale: 0.8,
            opacity: 0,
            transition: { duration: 0.5, ease: "easeInOut" }
        },
    };

    /* 
        const stepVariants = {
            hidden: transitionBack ? { x: "-100%", opacity: 0 } : { x: "100%", opacity: 0 },
            visible: { x: 0, opacity: 1 },
            exit: transitionBack ? { x: "100%", opacity: 0 } : { x: "-100%", opacity: 0 },
        };
    
       
     */

    useEffect(() => {
        QrAddressFech()
        QrAddressFechUSDC()
    }, [])



    return (
        <>
            {activeQoute && (
                <div className="fixed inset-0 flex items-center justify-center bg-[#0e0e10] bg-opacity-85 z-50">
                    <motion.div
                        className="bg-[#26262D] rounded-lg shadow-lg w-[90%] max-w-2xl max-h-[90vh] flex flex-col overflow-hidden"
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        {/* Header */}
                        <div className="p-6 flex-shrink-0">
                            <div className="w-full flex flex-row justify-between">
                                <p className="text-lg font-semibold text-white">
                                    Depositar con USDT/USDC
                                </p>
                                <IoCloseSharp
                                    size={25}
                                    color={"#b7b7b9"}
                                    onClick={() => setActiveQoute(false)}
                                    className="cursor-pointer"
                                />
                            </div>
                            <div className="h-[1.5px] w-full bg-[#16161d] mt-4"></div>
                        </div>

                        {/* Content - Make it scrollable if needed */}
                        <div className="flex-1 px-6 overflow-y-auto">
                            <motion.div
                                key="step3"
                                variants={modalVariants}
                                initial="hidden"
                                animate="visible"
                                exit="exit"
                                transition={{ duration: 0.5, ease: "easeOut" }}
                                className="pb-6"
                            >
                                <MultiQr
                                    loadingAddressQr={false}
                                    addressQrUSDC={addressQrUSDC}
                                    addressQrUSDT={addressQrUSDT}
                                />
                            </motion.div>
                        </div>
                    </motion.div>
                </div>

            )}

        </>
    );
};

export default ModalQuote;

